import { Box, styled, Typography } from "@mui/material";
import { FIRST_ROW_HEIGHT } from "./GameTimelineHeader.styles";
import { TEXT_ELLIPSIS } from "@shared/styles";

export const TeamIcon = styled("img")({
    width: "100%",
    height: "100%",
    objectFit: "contain",
});

export const TeamFullName = styled(Typography)({
    fontWeight: 700,
    lineHeight: "1.5",
    textAlign: "center",
    color: "var(--community-color-primary-text)",
    ...TEXT_ELLIPSIS,
});

export const TeamInfoContainer = styled(Box)({
    display: "flex",
    gap: "8px",
    alignItems: "center",
    height: FIRST_ROW_HEIGHT,
    minHeight: FIRST_ROW_HEIGHT,
    maxWidth: "100%",
});
